import { render, staticRenderFns } from "./ChangePasswordPopup.vue?vue&type=template&id=15106f97&scoped=true&"
import script from "./ChangePasswordPopup.vue?vue&type=script&lang=js&"
export * from "./ChangePasswordPopup.vue?vue&type=script&lang=js&"
import style0 from "./ChangePasswordPopup.vue?vue&type=style&index=0&id=15106f97&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15106f97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCol,VContainer,VDialog,VForm,VRow,VTextField})
